import React, {Component} from 'react';
import Grid from '@react/react-spectrum/Grid/js/Grid';
import GridColumn from '@react/react-spectrum/Grid/js/GridColumn';
import GridRow from '@react/react-spectrum/Grid/js/GridRow';
import Heading from '@react/react-spectrum/Heading';
import { Translate } from 'react-redux-i18n';
import { reduxForm } from 'redux-form';


class Finish extends Component{
    
    render(){
        return <div>
            <Grid>
            <GridRow>
                    <GridColumn size={[12,8,6,6]} offsetSize={[0,2,3,3]}>
                    <GridRow>
                        <GridColumn >
                            <Heading className = "textBold" variant="pageTitle"><Translate value="registration.thank_you" /></Heading>
                            <p><Translate value="registration.OnbrdThankYouNewRegistered" /></p>
                            <p><Translate value="registration.OnbrdThankYouHelpDesk" /></p>
                        </GridColumn>
                    </GridRow>
                    </GridColumn>
            </GridRow>
            </Grid>
            </div>
    }
}

Finish = reduxForm({
    form:'registration',
    destroyOnUnmount: false, //        <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  })(Finish);

export default Finish;